@if (!showOnlyCalendarPopup()) {
  <div class="saas-ui date-picker-wrapper">
    <label class="date-range-label">
      {{ label() }}
      <div
        #calendarInputWrapper
        class="input-wrapper"
        [style.height]="datePickerInputHeight() || null"
        (click)="toggleCalendar($event)">
        <input
          type="text"
          [value]="getDatePickerLabel()"
          [attr.size]="getDatePickerLabel().length || 10"
          readonly />
        <i class="material-symbols-outlined calendar-icon" aria-hidden="true">
          calendar_today
        </i>
      </div>
    </label>
    @if (compareEnabled) {
      <label class="compare" for="compareSwitchOutside">
        Compare
        <p-inputSwitch
          id="compareSwitchOutside"
          class="compare-switch mt-1"
          [(ngModel)]="compareToggledOn"
          (onChange)="onOutsideCompareToggle($event.checked)">
        </p-inputSwitch>
      </label>
    }
  </div>
}

@if (showCalendar) {
  <portal-fiscal-calendar-popup
    [months]="months()"
    [startDate]="startDate()"
    [endDate]="endDate()"
    [previousStartDate]="previousStartDate()"
    [previousEndDate]="previousEndDate()"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
    [relativeDate]="relativeDate()"
    [initialCompareOn]="forceCompareOn"
    (dateChanged)="onPopupDateChanged($event)"
    (cancelled)="onPopupCancelled()"
    (compareToggled)="compareToggledOn = $event">
  </portal-fiscal-calendar-popup>
}
